import React from 'react'
import { articleType } from '../article'
import { useNavigate } from 'react-router-dom'
import { BsCalendar, BsClock } from 'react-icons/bs'
import { AuthorTag } from '../extra/AuthorTag'
import { Tag } from '../extra/Tag'
import { format } from 'date-fns'

export const MostViewedArticleCard = (article: articleType) => {
  const navigate = useNavigate()

  const route = () => {
    navigate(`/articles/${article.id}`)
  }

  return (
    <div onClick={route} className='p-3 cursor-pointer'>
      <div className='flex gap-3 pb-2'>
        {article?.tags?.map((tag, idx) => (
          <Tag
            key={tag + idx}
            text={tag}
            className='font-medium text-xs px-[6px] py-[2px]'
          />
        ))}
      </div>

      <h3 className='text-base lg:text-2xl text-[#101828] font-medium lg:font-bold pb-4'>
        {article.title}
      </h3>

      <div
        className='flex 
                flex-col lg:flex-row
                items-start font-medium flex-wrap pb-6 gap-3'
      >
        <AuthorTag
          author={article?.author}
          pictureDimension='w-6 h-6 lg:w-8 lg:h-8'
          userNameClassName='text-[10px] lg:text-base font-regular lg:font-medium'
          occupationClassName='text-[8px] lg:text-xs font-regular lg:font-medium'
        />
        <div className='flex justify-center sm:justify-start w-full gap-3'>
          <span className='max-lg:hidden border-x-[1px] border-y-[15px] border-[#9FCDD7]' />
          <div className='flex items-center gap-2 text-[#001A3D]'>
            <BsCalendar />
            <span className='font-normal text-xs lg:text-base'>
              {format(new Date(article.publish_date), 'do MMMM yyyy')}
            </span>
          </div>
          <span className='border-x-[1px] border-y-[15px] border-[#9FCDD7]' />
          <div className='flex items-center gap-2 font-normal text-xs lg:text-base text-[#001A3D]'>
            <BsClock />
            <span>3 min to read</span>
          </div>
        </div>
      </div>

      <p className='line-clamp-4 lg:line-clamp-2 text-[#595A5C] text-xs lg:text-base font-medium tracking-wide'>
        {article.summary}
      </p>
    </div>
  )
}
